export function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <p className="site-footer__text">
          Rohingya Maps &mdash; Preserving identity through evidence, for memory and accountability.
        </p>
        <p className="site-footer__credit">
          &copy; {new Date().getFullYear()} Rohingya Maps Project. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
